export const GROUP_ORDERS_HREF =
  'https://business.grubhub.com/learning-center/enterprise-accounts/orders/placing-a-group-order/';
